import { progress_history_zh_CN } from "./progressHistory/zh_CN.progress-history";

export const zh_CN = {
    // footer
    company_name_footer: "国勘数字地球（北京）科技有限公司",
    company_name_footer_en: "Geological Survey Digital Earth(BeiJing)Technology Co.,Ltd.",
    address_footer: "地址：北京市昌平区新龙大厦",

    // header
    sign_out: "退出登录",
    project: "工区管理",
    data: "数据管理",
    progress: "专业计算",
    achievement: "成果展示",

    // speciality
    geology: "地质",
    seismic: "地震",
    well: "钻井",
    electricity: "电法",
    magnetism: "磁法",
    gravity: "重力",
    remotesense: "遥感",
    geochemical: "地化",
    resonance: "频域成像",
    noiseimage: "背景噪音成像",
    passivesswimage: "被动源面波成像",
    ftresonance: '频域成像_现场计算',
    rtresonance: '频率成像实时计算',
    activesurfacewave: "主动源面波成像V3.0",
    dataprocess: "数据处理",
    spacmaster: '微动成像',
    magnetic: "磁法",
    diffraction: "绕射",
    ewave2d: "二维弹性波正演模拟",
    rtcomputingsw: "被动源面波成像",
    rtcomputingpl: "震源追踪",
    awave2d: "二维声波正演模拟",
    fmodeling: "模型正演",
    migrationt: "二维常规偏移",
    tomoimage: '二维层析成像',
    surmigrationt: '起浮地表二维偏移',
    passivewave2d: '浅层被动源面波成像',
    twostation3d: '微动层析',
    surwavetomo: '面波层析',
    pwaveswib2d: '二维微动成像(长时)',

    twostation2d: '浅层微动层析成像',

    resonance3: '频域成像V3.0',
    passivewave31: '被动源面波成像LV3.1',

    // sign in
    sign_in: "登录",
    userName_err: "用户名或者密码错误！",
    userServer_disConnect: "服务器不可用",

    // project viewer
    active_project: "当前工区：",

    // project fliter
    province: "省：",
    city: "市：",
    project_name: "工区名：",

    // project information fliter
    project_proj_name: "测线名：",
    technology_class: "技术分类：",

    // selecter
    select_all: "全部",

    // alert
    close: "关闭",
    yes: "确定",
    no: "取消",

    // set project alert
    set_project_to: "设置当前工区为{projectName}？",

    // create project table
    current_project: "当前工区",
    create_project: "创建工区",
    empty: " ",
    please_choose: "请选择",
    province_empty: "请填写省市信息",
    city_empty: "请填写市信息",
    create_project_name: "工区名：",
    create_project_name_empty: "工区名不得为空",
    create_project_name_illegal: "工区名不合规",
    create_project_name_feedBack: "*6~15个字符，可使用字母、数字、下划线，需要以字母开头",
    PROJECT_ALIAS_feedBack: "可使用汉字、字母、数字、下划线，",
    create_project_author: "创建人：",
    create_project_author_empty: "创建人不得为空",
    create_project_author_illegal: "创建人不合规",
    create_project_author_feedBack: "*不能超过15个字符",
    create_project_date: "日期：",
    create_project_profile: "工区简介：",
    create_project_duplicate_name: "工区已经存在,请重命名。",

    // data nav
    raw: "原始数据",
    result: "成果数据",
    report: "专题报告",

    // data table fliter
    dir_name: "目录名:",
    file_name: "文件名:",
    data_extension: "数据类别",

    // no active project alert
    please_choose_project: "请先选择工区！",

    // table title
    serial_number: "序号",
    project_name_header: "工区名",
    province_header: "省",
    city_header: "市",
    author: "创建人",
    create_time: "创建时间",
    project_profile: "工区说明",
    progress_achievement: "计算结果",
    operation: "操作",
    information: "详细信息",
    delete: "删除",
    line_name: "数据目录",
    progress_category: "计算类别",
    show_data: "数据浏览",
    show: "浏览",
    speciality: "专业",
    data_category: "数据类别",
    file_count: "文件个数",
    file_size_MB: "大小",
    data_information: "详细信息",
    download: "下载",
    file_name_header: "文件名",
    size_MB: "大小",
    modification_time: "修改时间",
    user_name: "用户名",
    technology: "技术",
    comment: "备注",
    choose: "选择",
    job_name: "作业名",
    job_status: "作业状态",
    job_runing_message: "执行信息",
    update_time: "提交时间",
    module_name: "模块名",

    // pagenation
    records_per_page: "每页记录数",
    records: "记录总数",
    page_count: "页数",
    page_no: "当前页",
    first_page: "首页",
    per_page: "上一页",
    next_page: "下一页",
    last_page: "末页",

    // progress header
    progress_category_header: "计算类别:",
    module_category: "模块类别:",
    line: "测线:",
    new_line: "新建测线",
    reference_line: "请选择",

    module_list: "模块列表",
    reference: '参考测线:',
    referenceLine: '参考测线',
    module_param: "模块参数",

    // job status
    waiting: "等待",
    submiterror: "提交错误",
    error: "错误",
    start: "开始运行",
    running: "正在运行",
    complete: "完成",
    queue: "进入队列",
    // 新加的状态
    partcomplete: '分片作业完成',
    allcomplete: ' 实时计算作业完成',

    //progress
    submit: "提交",

    running_info: "运行信息",

    job_monitor: "作业监控",
    quality_show: "质控显示",
    quality_close: "质控隐藏",
    running_achievement: "运行结果图({number})",
    download_achievement: "计算成果下载",
    download_images: "图片下载",
    show_logs: "日志显示",

    // running info

    starttime: "开始时间",
    user: "用户",
    job_project: "工区",
    status: "状态",
    jobname: "作业名",
    runmsg: "运行信息",
    puttime: "更新时间",
    endtime: "结束时间",
    usetime: "作业执行时长",
    modulerunmsg: "专业模块运行信息",
    // twostation2dmid: '中深层微动层析成像',
    twostation2dmid: '微动层析成像V3.0',


    // kill
    kill: "中止",
    is_kill: "是否中止作业\"{jobName}\"？",

    quality_image_number: "图片总数:{number}",

    submit_success: "提交成功！",
    submit_failed: "提交失败",
    submit_ok: "确定",

    limit_download_size: "大于{size}MB的文件暂时不提供下载！",

    submit_wait: "{time}s",
    reflect: "反射",
    shreflect: '浅层反射',
    passivesurfacewave: "被动源面波成像V3.0",

    gis: "用户信息",
    design: '采集设计',
    monitor: '实时监控',
    messageShow: '国勘大屏',
    filedownload: '文件下载',
    userCenter: '用户中心',
    resonance1: '浅层频域成像 V2.0',
    ...progress_history_zh_CN
}
